// Shared `skip_shop_pay` checkout-URL state for the storefront extension.
//
// Shopify supports an (undocumented) `skip_shop_pay=true` query parameter on
// checkout URLs: when present, signed-in Shop Pay customers are NOT redirected
// to Shop Pay's accelerated checkout and instead land on the standard Shopify
// checkout. HSA/FSA merchants need this because the HSA payment method is only
// reachable from the standard checkout (see
// `team.settings.hsa.checkoutButtonsSkipShopPay`).
//
// The flag lives in this tiny main-bundle module (rather than the lazily
// loaded HSA bundle) so Redo-owned checkout navigations — Checkout+ buttons,
// the rescue panel, the Shop Pay buy-now flow — can consult it without pulling
// the HSA bundle into the main chunk. It is enabled once at init by the HSA
// controller (`src/hsa/initializer.tsx`) when the merchant's autocheck carries
// `hsa.checkoutButtonsSkipShopPay`. The parameter is per-navigation (Shopify
// does not persist it), so every entry into checkout must carry it.

export const SKIP_SHOP_PAY_PARAM = "skip_shop_pay";

let skipShopPayEnabled = false;

export function enableSkipShopPay(): void {
  skipShopPayEnabled = true;
}

export function isSkipShopPayEnabled(): boolean {
  return skipShopPayEnabled;
}

// Unconditionally appends `skip_shop_pay=true` to the given URL (idempotent).
// Relative URLs are resolved against the current origin. Returns the input
// unchanged if it cannot be parsed.
export function appendSkipShopPay(url: string): string {
  let parsed: URL;
  try {
    parsed = new URL(url, location.origin);
  } catch {
    return url;
  }
  parsed.searchParams.set(SKIP_SHOP_PAY_PARAM, "true");
  return parsed.toString();
}

// Appends `skip_shop_pay=true` only when the merchant-level flag has been
// enabled; otherwise returns the URL unchanged. Use this on Redo-owned
// checkout navigations.
export function applySkipShopPay(url: string): string {
  if (!skipShopPayEnabled) {
    return url;
  }
  return appendSkipShopPay(url);
}
